import { jwtDecode } from 'jwt-decode';

// Utility to decode JWT tokens and extract user information
export const decodeJWT = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

export const getUserFromToken = (token) => {
  if (!token) return null;
  
  const decoded = decodeJWT(token);
  if (!decoded) return null;

  return {
    id: decoded.sub || decoded.nameid,
    email: decoded.email,
    name: decoded.unique_name || decoded.name, // Use unique_name first, fallback to name
    userType: decoded.UserType || decoded.userType, // Check both possible claim names
    phoneNumber: decoded.phone_number
  };
};
